
export const SEARCH_OPT = {
    LIST: {
        category: null,
        searchValue: null,
    },
    PREVIEW: {
        category: null,
        searchValue: null,
    }
}
